import gql from 'graphql-tag'

const deleteAzione = gql`
  mutation deleteAzione($id: Int!) {
    deleteAzione(id: $id) {
      id
      utenteId
      utente {
        id
        nome
      }
      clienteId
      cliente {
        id
        nome
      }
      offertaId
      offerta {
        id
        nome
      }
      campagnaId
      campagna {
        id
        nome
      }
      tipoAzioneId
      tipoAzione {
        id
        tipo
      }
      appuntamentoAgenteId
      appuntamentoAgente {
        id
        nome
      }
      dataOra
      descrizione
      appuntamentoDaDataOra
      appuntamentoADataOra
      appuntamentoLuogo
      appuntamentoStato
      appuntamentoOrigine
      promemoriaUtenteId
        promemoriaUtente {
          id
          nome
          ruolo
        }
        promemoriaDataOra
        promemoriaDismesso
      votoAgente
      flagSondaggioInviato
      nonRisposto
    }
  }
`

export default deleteAzione


// WEBPACK FOOTER //
// ./src/graphql/mutations/deleteAzione.js